// extracted by mini-css-extract-plugin
export default {"root":"TextareaSimple_root__Wlfn5"};